import { MongoObservable } from 'meteor-rxjs';
import { Job } from '../models/job';

export const Jobs = new MongoObservable.Collection<Job>('jobs');

Jobs.allow({
  insert: function () {
    return false;
  },
  update: function () {
    return false;
  },
  remove: function () {
    return false;
  },
});

export const accessibleByCustomerIdsIndexName =
  'accessibleByCustomerIds_1_date_-1_department.name_1';

if (Meteor.isServer) {
  // index for hasOtherOverlappingJobs query optimization (should be used when booking a job)
  Jobs.rawCollection().createIndex({
    'invitees.userId': 1,
    'invitees.status': 1,
    date: 1,
  });

  // used for orderId generation to verify uniqueness
  Jobs.rawCollection().createIndex({ orderId: 1 });

  /** START indexes taken from db with high usages */
  // these indexes should be checked to see where they are used, and if they are actually benefitial, or if other indexes should cover these cases
  // most queries are scoped to a customer, and therefore these indexes should probably be taken over by "accessibleByCustomerIds" indexes
  // should be used by "sendInviteRemindersForCustomer"
  Jobs.rawCollection().createIndex(
    { status: 1, 'invitees.customer.id': 1, date: -1 },
    { name: 'status_inviteesCustomerId_date' },
  );

  Jobs.rawCollection().createIndex({ 'customer.id': 1, date: -1 });
  // should be used by "sendJobRemindersForCustomer"
  Jobs.rawCollection().createIndex({ 'invitees.customer.id': 1, date: -1 });
  Jobs.rawCollection().createIndex({ ownerCustomerIds: 1, date: -1 });
  Jobs.rawCollection().createIndex({
    status: 1,
    'transfers.targetCustomer.id': 1,
    date: -1,
  });
  /** END indexes taken from db with high usages */

  // main index for anything restricted by customer access
  Jobs.rawCollection().createIndex(
    {
      accessibleByCustomerIds: 1,
      date: -1,
      'department.name': 1,
    },
    {
      name: accessibleByCustomerIdsIndexName,
    },
  );

  // test index for open jobs query — status narrows out the large archived majority before date sort
  Jobs.rawCollection().createIndex(
    {
      accessibleByCustomerIds: 1,
      status: 1,
      date: 1,
      'department.name': 1,
    },
    { name: 'accessibleByCustomerIds_status_date_department.name' },
  );

  Jobs.rawCollection().createIndex({
    accessibleByCustomerIds: 1,
    'department.id': 1,
    date: -1,
    'department.name': 1,
  });
}
